<template>
    <div>
        <label
            v-for="option in options"
            :key="option.key"
            class="toggle-switch"
        >
            <input
                v-model="selectedFilters"
                class="toggle-switch__input"
                type="checkbox"
                :value="option.key"
            />
            <span class="toggle-switch__slider"></span>
            <span class="d-block">{{ option.value }}</span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            default() {
                return [];
            }
        },

        value: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    data() {
        return {
            selectedFilters: []
        };
    },

    watch: {
        selectedFilters(val) {
            this.$emit('input', val);
        }
    },

    created() {
        this.selectedFilters = this.value;
    },

    updated() {
        this.selectedFilters = this.value;
    }
};
</script>

<style lang="scss">
.toggle-switch {
    display: block;
    margin-bottom: 1rem;

    &:hover {
        cursor: pointer;
    }
}

.toggle-switch__input {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-switch__slider {
    position: relative;
    display: inline-block;
    vertical-align: bottom;
    margin-right: 1rem;
    cursor: pointer;
    min-width: 56px;
    width: 56px;
    height: 28px;
    background-color: $brand-gray;
    border-radius: 34px;
    transition: 0.4s;

    input:checked + & {
        background-color: $brand-green;
    }
}

.toggle-switch__slider:before {
    position: absolute;
    border-radius: 50%;
    content: '';
    height: 22px;
    width: 22px;
    left: 4px;
    bottom: 3px;
    background-color: $brand-white;
    transition: 0.4s;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);

    input:checked + & {
        transform: translateX(26px);
    }
}
</style>
